import Config from 'bz-stores/lib/config';
import { useEffect, useState } from 'react';
import { FieldDecimal, type IProps } from './field-decimal';

const FieldCurrency = (props: IProps) => {
  const [currencySymbol, setCurrencySymbol] = useState('_');

  useEffect(() => {
    Config.actions.getValue('CURRENCYSYMBOL').then((r) => {
      setCurrencySymbol(r.toString());
    });
  }, []);

  return <FieldDecimal {...props} prefix={currencySymbol} />;
};
export default FieldCurrency;
